/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['ConversationSummaryCollection', 'ConversationCollection'];

const ConversationsCtrl = function (ConversationSummaryCollection, ConversationCollection) {
  this.conversations = new ConversationSummaryCollection(`${this.clientId}_${this.attachedTo}`, {
    clientId: this.clientId,
    attachedTo: this.attachedTo,
  });
  this.conversations.$cacheAllModels(); // caches models for access in child components
  this.conversations.$fetch();

  // prefetch conversations for faster load time. Non-blocking.
  const conversationCollection = new ConversationCollection(`${this.clientId}_${this.attachedTo}`, {
    clientId: this.clientId,
    attachedTo: this.attachedTo,
  });

  conversationCollection.$cacheAllModels(); // caches models for access in child components
  conversationCollection.$fetch();

  this.select = id => {
    this.onSelect()(id);
    return this.conversations.$fetch();
  };
};

ConversationsCtrl.$inject = deps;

module.exports = ConversationsCtrl;
